/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import SignUpForm from "../../Component/Auth/SignUpForm";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/userprofile");
    }
  }, []);
  return <SignUpForm />;
};

export default SignUp;
